import React, { ComponentType } from 'react';
import { Nav, Box, Paragraph, IconBadge, IconProps } from '@landr/maestro';
import { RouterLink } from 'components/CommonUi';
export interface NavigationDropdownItemProps {
    onClick: (event: React.MouseEvent<Element, MouseEvent>) => void;
    icon: ComponentType<IconProps>;
    title: string;
    subTitle: string;
    path: string;
    target?: React.HTMLAttributeAnchorTarget;
}

export const NavigationDropdownItem: React.FC<NavigationDropdownItemProps> = ({
    onClick,
    icon: Icon,
    title,
    subTitle,
    path,
    target,
}) => {
    return (
        <Nav.DropdownItem
            key={path}
            as={RouterLink}
            to={path}
            onClick={onClick}
            target={target}
        >
            <Box display="flex" alignItems="flex-start" paddingBottom="0">
                <IconBadge icon={Icon} palette="samples" mr="md" />
                <Box>
                    <Box display="flex" alignItems="center">
                        <Box>
                            <Paragraph m="none" fontWeight="bold">
                                {title}
                            </Paragraph>
                        </Box>
                    </Box>
                    <Box wordBreak="break-word" textWrap="wrap">
                        <Paragraph
                            color="text.medium"
                            m="0"
                            textStyle="body-sm"
                        >
                            {subTitle}
                        </Paragraph>
                    </Box>
                </Box>
            </Box>
        </Nav.DropdownItem>
    );
};
